module.exports = __webpack_public_path__ + "static/img/pic19.ebb3f03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic19.png
// module id = yUn7
// module chunks = 0